import { LoadingOverlay } from "@sunrun/experience-ui-components";
import { useFeatureFlagEnabled } from "@sunrun/sales-experience-shared/react-feature-flags";
// eslint-disable-next-line import/no-restricted-paths
import { Academy } from "components/pages/Academy";
// eslint-disable-next-line import/no-restricted-paths
import { ErrorNotFound } from "components/pages/ErrorNotFound";
import { SALES_EXP_ACADEMY_PAGE_FLAG } from "constants/featureFlags";
import { useHybridToken } from "providers/Auth";
import { useUserProfile } from "providers/UserProfile";

const AcademyRoute = () => {
  const hybridToken = useHybridToken();
  const { userProfile } = useUserProfile();
  const academyPageEnabled = useFeatureFlagEnabled(SALES_EXP_ACADEMY_PAGE_FLAG);

  if (!hybridToken) {
    return null;
  }

  if (!userProfile?.contactId || academyPageEnabled === undefined) {
    return <LoadingOverlay message="Loading..." />;
  }

  if (!academyPageEnabled) {
    return <ErrorNotFound />;
  }

  return <Academy />;
};

export { AcademyRoute };
